const actualBtn = document.querySelector('.wpcf7-form-control-wrap.CV input[type="file"]');


const fileChosen = document.getElementById('file-chosen');

actualBtn && actualBtn.addEventListener('change', function(){
   fileChosen.textContent = this.files[0].name

   var removeLink = document.createElement('div');
   var file = this.files[0];
   const text = document.createTextNode("Remove");
   removeLink.classList.add('remove');
   removeLink.appendChild(text);
   removeLink.onclick = function() {
     removeimg()
   };
   fileChosen.append(removeLink);
   // console.log(fileChosen);

  function removeimg(){
    actualBtn.value = "";
    fileChosen.textContent = "";
   // if(confirm("Remove file?")){

   // }
  }
})
